import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faUserEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import api from '../../Api';

const EditSupervisorCati = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [user, setUser] = useState(null);
  const [form, setForm] = useState({ name: '', status: 'active' });
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/supervisor-catis/${id}`);
        setUser(res.data);
        setForm({ name: res.data.name, status: res.data.status });
      } catch (e) {
        setError(e.response?.data?.message || 'Erreur lors du chargement');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id]);

  const handleSave = async (e) => {
    e.preventDefault();
    setFieldErrors({});
    setError('');
    setSuccess('');
    setSaving(true);
    try {
      const res = await api.put(`/supervisor-catis/${id}`, form);
      setUser(res.data.user);
      setSuccess('Modifications enregistrées');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      if (err.response?.status === 422) {
        setFieldErrors(err.response.data.errors || {});
      } else {
        setError(err.response?.data?.message || 'Erreur lors de l\'enregistrement');
      }
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="p-12 text-center text-gray-500">
        <FontAwesomeIcon icon={faSpinner} className="animate-spin text-3xl mb-2" />
        <div>Chargement...</div>
      </div>
    );
  }

  if (!user) {
    return <div className="p-6 text-red-600">{error || 'Superviseur CATI introuvable.'}</div>;
  }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <div className="flex items-center gap-3 mb-6">
          <FontAwesomeIcon icon={faUserEdit} className="text-2xl text-red-600" />
          <div>
            <h1 className="text-xl font-bold text-gray-900">{user.name}</h1>
            <p className="text-sm text-gray-600">{user.email}</p>
          </div>
        </div>

        {success && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg">
            {success}
          </div>
        )}
        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <form onSubmit={handleSave} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nom complet</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className={`w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent ${
                fieldErrors.name ? 'border-red-400' : 'border-gray-300'
              }`}
            />
            {fieldErrors.name && <p className="mt-1 text-sm text-red-600">{fieldErrors.name[0]}</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Statut</label>
            <select
              value={form.status}
              onChange={(e) => setForm({ ...form, status: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
            >
              <option value="active">Actif</option>
              <option value="suspended">Suspendu</option>
              <option value="inactive">Inactif</option>
            </select>
            {fieldErrors.status && <p className="mt-1 text-sm text-red-600">{fieldErrors.status[0]}</p>}
          </div>

          <div className="pt-2 flex justify-end">
            <button
              type="submit"
              disabled={saving}
              className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
            >
              {saving ? (
                <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
              ) : (
                <FontAwesomeIcon icon={faSave} />
              )}
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSupervisorCati;
